import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAcceptingPolicy = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "acceptingPolicy",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24.028,
	viewBox: "0 0 24 24.028",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13113",
			"data-name": "Path 13113",
			d: "M0,.028H24v24H0v-24Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13114",
			"data-name": "Path 13114",
			d: "M6,6.028H18",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13115",
			"data-name": "Path 13115",
			d: "M8,3.028h8",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13116",
			"data-name": "Path 13116",
			d: "M19,9H5a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V11A2,2,0,0,0,19,9Z",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13117",
			"data-name": "Path 13117",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13118",
			"data-name": "Path 13118",
			d: "M14,12h4v3H14Z",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13119",
			"data-name": "Path 13119",
			d: "M6,15H9",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13120",
			"data-name": "Path 13120",
			d: "M6,18h5",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgAcceptingPolicy;
